import { getFontFamilies } from '@wix/thunderbolt-becky-root'
import { Component } from '@wix/thunderbolt-becky-types'
import { createCompNode, themeRefs } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'

export const masterPageFontFamilies = {
	predicate: (component: Component) => component.type === 'Document',
	compNode: createCompNode({
		getDependencies: () => themeRefs.themeFonts,
		toViewItem: (__, themeFontsMap) =>
			themeFontsMap ? Object.values(themeFontsMap).flatMap(getFontFamilies) : EMPTY_ARRAY,
	}),
}
